import React from 'react';
import classnames from 'classnames';
import Radio from '../../../../../components/form/Radio';

const MembershipOption = ({
  priceId,
  onChange,
  noMembership,
  isSelected,
  label,
  extraText,
}: {
  priceId: string;
  onChange: (value: string) => void;
  noMembership: boolean;
  isSelected: boolean;
  label: string;
  extraText?: string;
}) => {
  return (
    <div
      className={classnames('MembershipOption position-relative', {
        isSelected,
        noMembership,
      })}
    >
      <Radio
        id={priceId}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
        value={priceId}
        checked={isSelected}
      />
      <label htmlFor={priceId} className='label'>
        <div className='label'>{label}</div>
        <div className='extraText'>{extraText}</div>
      </label>
    </div>
  );
};

export default MembershipOption;
